import { useEffect, useRef } from 'react';
import { useEnsureFirstMailbox } from './api';

/**
 * Первый вход в услугу: пользователь должен попасть на главную с уже созданным ящиком
 * (promt-81 §Q4). Запрос идемпотентен на бэкенде, но лишний раз его не шлём —
 * только когда список ящиков загрузился и оказался пустым.
 */
export function useFirstMailboxBootstrap(enabled: boolean, listLoaded: boolean, isEmpty: boolean) {
  const ensure = useEnsureFirstMailbox();
  const requested = useRef(false);

  useEffect(() => {
    if (!enabled || !listLoaded || !isEmpty || requested.current) return;
    requested.current = true;
    ensure.mutate();
  }, [enabled, listLoaded, isEmpty, ensure]);

  return ensure.isPending;
}
